import React, { useEffect } from "react";
import NotificationService from "../../service/notificationServices";
import { useDispatch, useSelector } from "react-redux";
import { setNotifications } from "../../store/actions";

function Notification(props) {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);
  const user = useSelector((state) => state.user);
  const { User_id } = user.currentUser;

  useEffect(() => {
    const getData = async () => {
      const notificationsService = new NotificationService();
      const getOlderNotification = notifications.olderNotifications.length === 0 ? 1 : 0;
      if (getOlderNotification) {
        const data = await notificationsService.getNotifications(User_id, getOlderNotification);
        if (data.success) {
          const notificationsData = data.data;
          dispatch(
            setNotifications({
              todayNotifications: notificationsData.todayNotifications,
              ...(getOlderNotification ? { olderNotifications: notificationsData.olderNotifications } : {}),
              notSeenNotificationCount: notificationsData.notSeenNotificationCount,
            })
          );
        }
      }
    };

    getData();
  }, [User_id, dispatch, notifications.olderNotifications.length, user]);

  return props.children;
}

export default React.memo(Notification);
